import React from "react"
import "./footer.css"
import { Link } from "gatsby"
import Mailchimp from 'react-mailchimp-form'

import logo from '../../images/logo/logo.svg'
import { GUIDES } from '../../data/guides'

const SOCIAL = [
    { href: "https://www.pinterest.com/vibrahub/", label: "Pinterest", icon: "social_pinterest" },
    { href: "https://www.facebook.com/vibrahub", label: "Facebook", icon: "social_facebook" },
    { href: "https://www.instagram.com/vibrahub/", label: "Instagram", icon: "social_instagram" },
]

export default function Footer() {
    const year = new Date().getFullYear()
    return (
        <div className="footer-area-wrapper" style={{ background: '#fbfbfb' }}>
            <div className="footer-area section-space--ptb_120">
                <div className="container">
                    <div className="row footer-widget-wrapper">
                        <div className="col-lg-3 col-md-4 col-sm-6 footer-widget">
                            <h6 className="footer-widget__title mb-20">Products</h6>
                            <ul className="footer-widget__list">
                                <li><Link to="/vibra-one/" className="hover-style-link">Vibra One phone booth</Link></li>
                                <li><Link to="/products/" className="hover-style-link">Vibra Four meeting pod</Link></li>
                                <li><Link to="/virtual-demo/" className="hover-style-link">Book a virtual demo</Link></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 footer-widget">
                            <h6 className="footer-widget__title mb-20">Guides</h6>
                            <ul className="footer-widget__list">
                                {GUIDES.map((g) => (
                                    <li key={g.slug}><Link to={`/guides/${g.slug}/`} className="hover-style-link">{g.shortTitle}</Link></li>
                                ))}
                                <li><Link to="/guides/" className="hover-style-link">All guides</Link></li>
                            </ul>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6 footer-widget">
                            <h6 className="footer-widget__title mb-20">Company</h6>
                            <ul className="footer-widget__list">
                                <li><Link to="/about-us/" className="hover-style-link">About us</Link></li>
                                <li><Link to="/contact-us/" className="hover-style-link">Contact us</Link></li>
                                <li><a href="mailto:info@vibrahub.com" className="hover-style-link">info@vibrahub.com</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 footer-widget">
                            <h6 className="footer-widget__title mb-20">Newsletter</h6>
                            <div className="footer-widget__newsletter mt-30">
                                Occasional news from Vibra: new products, workplace research and offers. No more than one email a month. <br /><br />
                                <Mailchimp
                                    action='https://vibrahub.us7.list-manage.com/subscribe/post?u=95855aed4330e67093dea96b3&amp;id=03991f77c6'
                                    buttonClassName={"submit-button"}
                                    fields={[
                                        {
                                            name: 'EMAIL',
                                            placeholder: 'Your email address',
                                            type: 'email',
                                            required: true,
                                        }
                                    ]}
                                    messages={{
                                        sending: "Sending...",
                                        success: "Thank you for subscribing!",
                                        error: "Something went wrong. Please try again or email info@vibrahub.com.",
                                        empty: "Please enter your email address.",
                                        duplicate: "This address is already subscribed.",
                                        button: "->"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-copyright-area section-space--pb_30">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-5 text-center text-md-left">
                            <ul className="footer-widget__footer-menu">
                                <li><Link to="/terms-and-conditions/">Terms &amp; Conditions</Link></li>
                                <li><Link to="/privacy-policy/">Privacy</Link></li>
                                <li><a href="/sitemap.xml">Sitemap</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-2 text-center">
                            <div className="footer-logo">
                                <Link to="/"><img src={logo} alt="VibraHub" /></Link>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5 order-md-3">
                            <div className="footer-bottom-social">
                                <h6 className="title">Follow us</h6>
                                <ul className="list footer-social-networks ">
                                    {SOCIAL.map((s) => (
                                        <li className="item" key={s.href}>
                                            <a href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
                                                <i className={`social ${s.icon}`}></i>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <span className="copyright-text text-center  section-space--mt_40">&copy; {year} Vibra Hub. All rights reserved.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
